<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Provider Citizenships'"
        :buttons="[
          {
            title: 'Reflesh',
            icon: 'fas fa-redo-alt',
            emit: 'get',
          },
        ]"
        @get="get"
      ></cardHead>
      <load-area v-if="data == null"></load-area>
      <dataTable
        :name="'KolayrezCitizenships'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @unMatch="unMatch($event)"
        @cellClicked="matchShow = $event.data"
        v-if="data != null"
        :addContextMenuItem="getContextMenuItems"
        :rowClassRules="{
          // row style function
          success: (params) => {
            // var numSickDays = params.data;
            return params?.data?.CountryId != null;
          },
          rowClass: (params, select) => {
            // var numSickDays = params.data;
            return params?.data?.Id == select || select == undefined;
          },
          warning: (params) => {
            // var numSickDays = params.data;
            return params?.data?.NoMatch;
          },
        }"
      ></dataTable>
      <match
        v-if="matchShow != null"
        :countries="countries"
        @setCountries="setCountries($event)"
        :setModel="matchShow"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="matchShow = null"
      ></match>
    </div>
  </div>
</template>

<script>
import match from "./match";
export default {
  name: "providerCitizenships",
  components: { match },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Provider",
          filter: "agTextColumnFilter",
          field: "ProviderName",
          flex: 2,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ProviderAgencyName",
          filter: "agTextColumnFilter",
          field: "ProviderAgencyName",
          flex: 1,
          minWidth: 200,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ProviderCitizenshipName",
          filter: "agTextColumnFilter",
          field: "ProviderCitizenshipName",
          flex: 1,
          minWidth: 220,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ISO2",
          filter: "agTextColumnFilter",
          field: "ISO2",
          flex: 1,
          minWidth: 70,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="far fa-times-circle"></i>',
              emit: "unMatch",
              if: (data) => {
                return data.CountryId != null;
              },
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      matchShow: null,
      countries: [],
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`kolayrez/ProviderCitizenships`)
        .then((response) => {
          this.data = response.data.sort((x, y) => {
            return y.Id - x.Id;
          });
          console.log(
            "--",
            this.data.filter((x) => x.CountryId == null)
          );
        });
    },
    setCountry(item) {
      var data = this.countries;
      data.unshift({
        Id: item.Id,
        Name: item.Name,
      });
      this.$emit("setCountries", data);
    },
    setCountries(items) {
      var data = [];
      items.forEach((item) => {
        data.unshift({
          Id: item.Id,
          Name: item.ISO2 + " - " + item.Name,
        });
      });
      this.countries = data;
    },
    unMatch(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text:
          "Do you want to unmatch the provider citizenships named " +
          item.Name +
          " ?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .post(`KOLAYREZ/ProviderCitizenships/Match/`, {
              Id: item.Id,
              CountryId: null,
            })
            .then(() => {
              this.$refs.agGrid.changeRow("Id", {
                ...item,
                CountryId: null,
                ISO2: null,
              });
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Provider citizenships match has been cancelled.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Match Provider Citizenship",
          icon: "<i class='fas fa-exchange-alt'></i>",
          action: () => {
            this.matchShow = params.node.data;
          },
        },
        {
          name: params.node.data.NoMatch
            ? "Yes Match Provider Citizenship"
            : "No Match Provider Citizenship",
          icon: !params.node.data.NoMatch
            ? "<i class='fas fa-ban'></i>"
            : '<i class="far fa-check-circle"></i>',
          action: () => {
            this.$appAxiosAdmin
              .post(`kolayrez/ProviderCitizenships/UpdateNoMatch`, {
                Id: params.node.data.Id,
                NoMatch: !params.node.data.NoMatch,
              })
              .then(() => {
                this.$refs.agGrid.changeRow("Id", {
                  ...params.node.data,
                  NoMatch: !params.node.data.NoMatch,
                });
              });
          },
        },
      ];
      return result;
    },
  },
};
</script>
